#import "./ImageFull.graphql"
#import "./CustomerRequirementFull.graphql"

fragment OrderProductOptionsFull on OrderProductOptions {
  creamColor
  customerRequirement {
    ...CustomerRequirementFull
  }
  extraFruit
  figurines {
    id
    description
    price
    status
  }
  filling
  glutenFree
  inscription {
    status
    text
  }
  labels {
    id
    text
    status
  }
  lactoseFree
  lyingPhoto {
    id
    file {
      ...ImageFull
    }
    url
    status
  }
  macaroons {
    chocolate
    lemon
    pistachio
    raspberry
    saltedCaramel
  }
  meringues
  numbers {
    id
    number
  }
  standingPhotos {
    id
    file {
      ...ImageFull
    }
    url
    status
  }
}
